import { describeError } from "../utils/error_message";

const KEY = "authResume";
/** Long enough for an e-mail code or a Google round trip, short enough not to surprise later. */
export const RESUME_TTL_MS = 10 * 60 * 1000;
export const RESUME_EVENT = "onbible:auth-resume";

export type ResumeAction =
	| "support"
	| "ask-question"
	| "start-course"
	| "copy-note"
	| "study-courses";
export type ResumeMarker = { action: ResumeAction; payload?: string };

export const clearResume = (): void => {
	try {
		localStorage.removeItem(KEY);
	} catch (error) {
		console.error("Failed to clear the resume marker", describeError(error));
	}
};

/** What to continue once the reader is back from sign-in. Nothing they typed is kept. */
export const rememberResume = (marker: ResumeMarker): void => {
	try {
		localStorage.setItem(KEY, JSON.stringify({ ...marker, at: Date.now() }));
	} catch (error) {
		console.error("Failed to keep the resume marker", describeError(error));
	}
	window.dispatchEvent(new Event(RESUME_EVENT));
};

/** The marker for `action`, once and while fresh; another action's marker is left alone. */
export const takeResume = (action: ResumeAction, now: number = Date.now()): ResumeMarker | null => {
	let raw: string | null;
	try {
		raw = localStorage.getItem(KEY);
	} catch (error) {
		console.error("Failed to read the resume marker", describeError(error));
		return null;
	}
	if (!raw) return null;
	try {
		const { action: stored, payload, at } = JSON.parse(raw);
		if (stored !== action) return null;
		clearResume();
		if (now - at > RESUME_TTL_MS) return null;
		return typeof payload === "string" ? { action, payload } : { action };
	} catch {
		clearResume();
		return null;
	}
};
